export default class PremiumCalculatorAbstractServices {
  static getPremiumCalculatorReferenceData() {
    logger.error(`PremiumCalculator:: getPremiumCalculatorReferenceData() not implemented`);
  }

  static calculatePremium() {
    logger.error(`PremiumCalculator:: calculatePremium() not implemented`);
  }
}
